const COLUMNS = ["date", "amount", "type", "category", "description"];

function csvCell(value) {
  const text = String(value ?? "");
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildTransactionsTemplate(categories) {
  const rows = [COLUMNS];

  for (const kind of ["income", "expense"]) {
    for (const category of categories?.[kind] || []) {
      rows.push(["", "", kind, category.name, ""]);
    }
  }

  // Excel uses the BOM to recognize UTF-8 category names reliably.
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(",")).join("\r\n")}\r\n`;
}
